"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        // Required manual capture for root layout errors
        Sentry.captureException(error);
    }, [error]);

    return (
        <html>
            <head>
                <title>Something went wrong!</title>
            </head>
            <body>
                <div className="flex flex-col items-center justify-center min-h-screen bg-slate-900 text-white p-4">
                    <h1 className="text-4xl font-bold mb-4">A critical error occurred</h1>
                    <p className="text-slate-400 mb-8 max-w-md text-center">
                        The application encountered a rendering error in the root layout. We've been notified.
                    </p>
                    <button
                        onClick={() => reset()}
                        className="px-6 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors font-medium text-lg"
                    >
                        Try again
                    </button>
                </div>
            </body>
        </html>
    );
}
